import React, { useEffect } from 'react';
import { makeStyles, Theme, Grid } from '@material-ui/core';
import { ZipModel } from 'types/zipModel';
import SearchListItemComponent from 'views/search/components/searchListItemComponent';
import LogUtils from 'utils/logUtils';

/***********************************************************************
 * 型定義
 ***********************************************************************/
export type SearchListProps = {
  zipModelList: Array<ZipModel>;
};

/***********************************************************************
 * Style
 ***********************************************************************/
/**
 * スタイル定義
 * @name useStyles
 */
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    marginTop: '20px',
  },
}));

/***********************************************************************
 * メイン処理
 ***********************************************************************/
/**
 * 郵便番号情報結果一覧画面
 * @name SearchListComponent
 */
const SearchListComponent: React.FC<SearchListProps> = ({ zipModelList }) => {
  /**
   * クラス名
   * @name className
   * @member
   */
  const className = 'SearchListComponent';

  /**
   * スタイル取得
   * @name classes
   * @member
   */
  const classes = useStyles();

  /**
   * 副作用フック
   * @name useEffect
   * @function
   */
  useEffect(() => {
    /**
     * 初期設定処理
     * @name init
     * @event
     */
    const init = async () => {
      const methodName = 'init';
      try {
        LogUtils.info(`${className} ${methodName} start`);
        LogUtils.info(`${className} ${methodName} end`);
      } catch (e) {
        LogUtils.info(`${className} ${methodName} Error: ${e}`);
      }
    };
    init();
  }, []);

  /***********************************************************************
   * 画面の定義
   ***********************************************************************/
  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        {zipModelList.map((zipModel) => (
          <Grid key={zipModel.zip} item xs={12}>
            <SearchListItemComponent
              zipModel={zipModel}
            ></SearchListItemComponent>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default SearchListComponent;
